export default "__VITE_ASSET__BAOdcyhi__"